module.exports = __webpack_public_path__ + "img/logo__synak-test--full-light.02c81aa1.svg";